import { render, staticRenderFns } from "./HistoryRecordsGrid.vue?vue&type=template&id=c05b3ed4&scoped=true"
import script from "./HistoryRecordsGrid.vue?vue&type=script&lang=js"
export * from "./HistoryRecordsGrid.vue?vue&type=script&lang=js"
import style0 from "./HistoryRecordsGrid.vue?vue&type=style&index=0&id=c05b3ed4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c05b3ed4",
  null
  
)

export default component.exports